import React from 'react';
import anime from 'animejs';
import { PageProps } from '../components/component-switcher';
import {
  // CategorisedArchiveProps,
  CategorisedItem,
} from '../pages/categorised-archve';
import { ArchiveCategoryProps } from '../pages/archive-category';

export function generateSectionId(section: PageProps) {
  return section.title.toLowerCase().split(' ').join('-');
}

export function scrollTo(ref: React.RefObject<any>, duration: number): void {
  if (!ref || !ref.current) {
    return;
  }

  //account for the menubar height
  let menuHeight = 73;
  let padding = 25;
  let offset: number = menuHeight + padding;

  let rect = ref.current.getBoundingClientRect();
  let scollingEl = document.querySelector('.container');
  if (scollingEl === null) {
    return;
  }
  let top = rect.top - offset + scollingEl.scrollTop;

  anime({
    targets: scollingEl,
    duration: duration,
    easing: 'easeOutQuad',
    scrollTop: top,
  });
}

export function scrollToTop(): void {
  let scollingEl = document.querySelector('.container');
  if (scollingEl === null) {
    return;
  }

  anime({
    targets: scollingEl,
    duration: 300,
    easing: 'easeOutQuad',
    scrollTop: 0,
  });
}

export function inView(node: any) {
  if (node === undefined) {
    return false;
  }

  let clientRect = node.getBoundingClientRect();
  //   if (node.id === 'typografi') {
  //     console.log(node, clientRect);
  //   }
  //   var mid = 0;
  if (clientRect.top < 500) {
    return true;
  } else return false;
}

export function inViewBottom(node: any) {
  if (node === undefined) {
    return false;
  }

  let clientRect = node.getBoundingClientRect();
  const bottom = clientRect.bottom;
  if (bottom < window.innerHeight && bottom > 0) {
    return true;
  }

  //if (clientRect.bottom > window.scrollY) {
  //    item.viewed = true;
  //    return true;
  //}

  return false;
}

export function hasCategories(items: any[]) {
  items?.forEach((item: CategorisedItem) => {
    if (item.tags?.length > 0) {
      return true;
    }
  });

  return false;
}

export function createCategories(
  items: any[],
  component: any
): ArchiveCategoryProps[] {
  let categories: { [id: string]: ArchiveCategoryProps } = {};
  items?.forEach((item: any) => {
    if (!item.tags || item.tags.length === 0) {
      if (categories['noCategory'] === undefined) {
        categories['noCategory'] = {
          itemChildren: [],
          component,
          ...item,
          key: 'noCategory',
        };
      }
      categories['noCategory'].itemChildren.push(item);
    } else {
      item.tags?.forEach((tag: string) => {
        if (categories[tag] === undefined) {
          let newTag: ArchiveCategoryProps = {
            heading: tag,
            itemChildren: [],
            component,
            ...item,
            key: tag,
          };
          categories[tag] = newTag;
        }

        categories[tag].itemChildren.push(item);
      });
    }
  });

  return Object.values(categories);
}
